import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
//import ModalAgregarLineasScorecard from './ModalAgregarLineasScorecard';
import { LoaderScreen } from "../../components/LoaderScreen";
import { FiltroPlantillasKarbot } from "./FiltroPlantillaKarbot";
import { GetMonthName } from "../../helpers/GetMonthName";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { Checkbox } from "@mui/material";
import Button from "@mui/material/Button";
import { ModalGuardarTelefono } from "./ModalGuardarTelefono";

export const PlantillasKarbotScreen = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [selectedItems, setSelectedItems] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
    onExecute(state.cartera, state.ejercicio, state.periodo, state.telefono);
  };
  const [idTelefono, setIdTelefono] = useState("");

  const [state, setState] = useState({
    cartera: "",
    linea: "R",
    telefono: "",
  });
  const [titulo, setTitulo] = useState("PLANTILLA KARBOT");
  const [data, setData] = useState([]);

  const onExecute = (linea, cartera, telefono) => {
    setState((prevState) => ({
      ...prevState,
      cartera,
      linea,
      telefono,
    }));
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });

      var controller =
        linea === "R"
          ? "CargarPlantillasKarbot"
          : "CargarPlantillasKarbotOperacion";
      request
        .get(
          `CargaPlantillasKarbot/${controller}?linea=${linea}&cartera=${cartera}&telefono=${telefono}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setData(result);
          setTitulo(
            `PLANTILLA KARBOT DE CARTERA DE ${
              linea === "R" ? "REVOLVENTE" : "OPERACION"
            } ${cartera === "V" ? " VENCIDA" : " POR VENCER"}`
          );
          setState({
            ...state,
            cartera,
            linea,
          });
          resolve("");
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          setTitulo("PLANTILLA KARBOT");
          reject(error);
          return;
        });
    });
  };

  const onGuardar = () => {
    const { cartera, linea } = state;

    const dataToUpdate = data.map((item) => {
      if (selectedItems.includes(item)) {
        item.aprobado = 1;
      } else {
        item.aprobado = 0;
      }
      item.ejercicio = new Date().getFullYear();
      item.periodo = new Date().getMonth();
      return item;
    });
    const mdl = {
      cartera,
      linea,
      listado_plantillas: JSON.stringify(dataToUpdate),
    };

    request
      .post("GuardaPlantillasKarbot/GuardarPlantillas", mdl)
      .then(() => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "PLANTILLAS KARBOT",
          "Plantillas guardadas correctamente",
          "success"
        );
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PLANTILLAS KARBOT", JSON.stringify(error), "error");
      });
  };
  useEffect(() => {
    setSelectedItems(
      data.filter(
        (item) =>
          item.aprobado === 1 ||
          item.aprobado === null ||
          item.aprobado === undefined
      )
    );

    // data.forEach((item) => {
    //   if (item.aprobado === null || item.aprobado === undefined) {
    //     item.aprobado = 1;
    //   }
    // });
  }, [data]);
  const totalClientesEncontrados = data.length;

  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"plantillas-karbot-main-screen"}
    >
      <LoaderScreen loader={loader} />
      <div className="plantillas-karbot-actions">
        <div
          className="plantillas-karbot-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <FiltroPlantillasKarbot onExecute={onExecute} />
      </div>
      <div className="plantillas-karbot-numero-clientes">
        {`Se encontraron ${totalClientesEncontrados} cliente(s)`}
      </div>
      {data === undefined || data === null || data.length === 0 ? (
        <div></div>
      ) : (
        <div className="plantillas-karbot-table scroll-4">
          {state.linea === "R" ? (
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>
                    <div>Aprobar</div>
                  </th>
                  <th>
                    <div>ID Cliente</div>
                  </th>
                  <th>
                    <div>Razón Social</div>
                  </th>
                  <th>
                    <div>Teléfono</div>
                  </th>
                  <th>
                    <div>Referencia Bancaria</div>
                  </th>
                  <th>
                    <div>Saldo</div>
                  </th>
                  {/* <th>
                    <div>Enviado</div>
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr>
                    <td>
                      <Checkbox
                        checked={
                          item.aprobado === 1 ||
                          item.aprobado === null ||
                          item.aprobado === undefined
                        }
                        disabled={item.enviado === 1}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedItems([...selectedItems, item]);
                            item.aprobado = 1;
                          } else {
                            setSelectedItems(
                              selectedItems.filter(
                                (selectedItem) => selectedItem !== item
                              )
                            );
                            item.aprobado = 0;
                          }
                        }}
                      />
                    </td>
                    <td>{item.idcliente}</td>
                    <td>{item.cliente}</td>
                    <td
                      onClick={() => {
                        if (item.contacto === "No Registrado") {
                          setOpenModal(true);
                          setIdTelefono(item.idcliente);
                        }
                      }}
                      style={{
                        cursor:
                          item.contacto === "No Registrado"
                            ? "pointer"
                            : "default",
                      }}
                    >
                      {item.contacto}
                    </td>
                    <td>{item.referencia}</td>
                    <td>{FormatMoney(item.saldo, 0)}</td>
                    {/* <td>{item.enviado === 0 ? "-" : "Enviado"}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>
                    <div>Aprobar</div>
                  </th>
                  <th>
                    <div>ID Cliente</div>
                  </th>
                  <th>
                    <div>Razón Social</div>
                  </th>
                  <th>
                    <div>Teléfono</div>
                  </th>
                  <th>
                    <div>Referencia Bancaria</div>
                  </th>
                  <th>
                    <div>Saldo</div>
                  </th>
                  <th>
                    <div>Capital</div>
                  </th>
                  <th>
                    <div>Pactado</div>
                  </th>
                  <th>
                    <div>Moratorio</div>
                  </th>
                  {/* <th>
                    <div>Enviado</div>
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr>
                    <td>
                      <Checkbox
                        checked={
                          item.aprobado === 1 ||
                          item.aprobado === null ||
                          item.aprobado === undefined
                        }
                        disabled={item.enviado === 1}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedItems([...selectedItems, item]);
                            item.aprobado = 1;
                          } else {
                            setSelectedItems(
                              selectedItems.filter(
                                (selectedItem) => selectedItem !== item
                              )
                            );
                            item.aprobado = 0;
                          }
                        }}
                      />
                    </td>
                    <td>{item.idcliente}</td>
                    <td>{item.cliente}</td>
                    <td
                      onClick={() => {
                        if (item.contacto === "No Registrado") {
                          setOpenModal(true);
                          setIdTelefono(item.idcliente);
                        }
                      }}
                      style={{
                        cursor:
                          item.contacto === "No Registrado"
                            ? "pointer"
                            : "default",
                      }}
                    >
                      {item.contacto}
                    </td>
                    <td>{item.referencia}</td>
                    <td>{FormatMoney(item.saldo, 0)}</td>
                    <td>{FormatMoney(item.capital, 0)}</td>
                    <td>{FormatMoney(item.interes_pactado, 0)}</td>
                    <td>{FormatMoney(item.interes_moratorio, 0)}</td>
                    {/* <td>{item.enviado === 0 ? "-" : "Enviado"}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
      <ModalGuardarTelefono
        open={openModal}
        handleCloseModal={handleCloseModal}
        idcliente={idTelefono}
      />
      <div className="btn-guardar">
        <Button variant="contained" onClick={() => onGuardar()}>
          Guardar
        </Button>
      </div>
    </PlantillaScreen>
  );
};
